export enum BalanceToAdjust {
  BORROWER_FUNDED_ESCROW = 'Borrower Funded Escrow',
  CORPORATE_ADVANCE = 'Corporate Advance',
  ESCROW_ADVANCE = 'Escrow Advance',
  INTEREST_BEARING_INTEREST_RESERVE = 'Interest Reserve (Interest Bearing)',
  NON_INTEREST_BEARING_INTEREST_RESERVE = 'Interest Reserve (Non-Interest Bearing)',
  INTEREST_BEARING_PRINCIPAL_RESERVE = 'Principal Reserve (Interest Bearing)',
  NON_INTEREST_BEARING_PRINCIPAL_RESERVE = 'Principal Reserve (Non-Interest Bearing)',
  TAX_INSURANCE_ADVANCE = 'Tax Insurance Advance',
}

export interface BalanceToAdjustOption {
  id: string
  name: string
}

export type BalanceToAdjustKey = keyof typeof BalanceToAdjust

export const balanceToAdjustOptions: BalanceToAdjustOption[] = Object.entries(
  BalanceToAdjust,
).map(([propertyKey]) => ({ id: propertyKey, name: propertyKey }))

export const balanceToAdjustKeys = Object.keys(
  BalanceToAdjust,
) as BalanceToAdjustKey[]
